import classNames from 'classnames'
import React from 'react'
import styles from './styles.module.scss'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type Props = {
  className?: string
  reverse?: boolean
  children: React.ReactNode
  href?: string
  newTab?: boolean
}

export const RainbowButton: React.FC<Props> = ({ href, className, children, reverse, newTab = true }) => {
  const attr = newTab ? { target: '_blank', rel: 'noreferrer' } : undefined
  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a href={href} className={classNames(styles.container, reverse && styles.reverse, className)} {...attr}>
      <div className={styles.blur} />
      <div className={styles.border} />
      <button>{children}</button>
    </a>
  )
}

type LargeProps = Props & {
  icon: IconDefinition
}

export const LargeRainbowButton: React.FC<LargeProps> = ({ href, className, children, reverse, icon, newTab = true }) => {
  const attr = newTab ? { target: '_blank', rel: 'noreferrer' } : undefined
  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a href={href} className={classNames(styles.container, styles.large, reverse && styles.reverse, className)} {...attr}>
      <div className={styles.blur} />
      <div className={styles.border} />
      <button>
        <FontAwesomeIcon icon={icon as IconDefinition} className={styles.icon} />
        <div className={styles.content}>{children}</div>
      </button>
    </a>
  )
}
